"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressAppointment = void 0;
class ExpressAppointment {
    constructor(props) {
        this.alta = props?.alta || null;
        this.answer = props?.answer || "";
        this.country = props?.country || "AR";
        this.timestamps = props?.timestamps || {};
        this.id = props?.id;
        this.info = props?.info || {
            days: "",
            symptoms: "",
            symptonsDetails: "",
            vaccine: ""
        };
        this.patient = props?.patient || {
            email: "",
            name: "",
            uid: "",
        };
        this.provider = props?.provider || {
            cuit: "",
            fullname: "",
            uid: "",
        };
        this.question = props?.question || "";
        this.status = props?.status || "SUSPENDED";
        this.useful = props?.useful || null;
    }
}
exports.ExpressAppointment = ExpressAppointment;
